export const acfGroupName = {
  section: {
    atAGlance: 'Page_Acfcontent_Section_AtAGlance',
    features: 'Page_Acfcontent_Section_Features',
    highlights: 'Page_Acfcontent_Section_Highlights',
  },
};
